import { ComponentProps, lazy, Suspense } from "react";

import type { ExtractionPanel as ExtractionPanelComponent } from "./extraction-panel";

import { Dialog } from "../../../components/ui-kit/dialog";
import { Spinner } from "../../../components/ui-kit/spinner";
import { EXTRACTION_DIALOG_CLASS } from "./extraction-dialog";

// Type-only import above, so naming the props here does not pull the module
// (and with it pdfjs) into the importing chunk.
type Props = ComponentProps<typeof ExtractionPanelComponent>;

const ExtractionPanel = lazy(async () => ({
  default: (await import("./extraction-panel")).ExtractionPanel,
}));

/**
 * The review panel behind a dynamic import. It carries pdfjs (~400 KB
 * minified), which no route needs until someone opens a document — the app has
 * no route-level code splitting, so a static import would put it in the bundle
 * every user downloads.
 */
export function ExtractionPanelLazy(props: Props) {
  return (
    <Suspense
      fallback={
        // Opened at the panel's own size, so the card the reviewer clicked
        // into does not resize under them when the chunk lands.
        <Dialog
          open
          onOpenChange={(o) => !o && props.onClose()}
          className={EXTRACTION_DIALOG_CLASS}
        >
          <div className="flex flex-1 items-center justify-center">
            <Spinner />
          </div>
        </Dialog>
      }
    >
      <ExtractionPanel {...props} />
    </Suspense>
  );
}
